// Dependencies
import React from 'react';
import { ThemeContext } from '../../components/theme/Theme.jsx';
import radium from 'radium';

function Description(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		desciptionDefault: {
			whiteSpace: 'pre-wrap',
			wordBreak: 'keep-all',
		},
		descriptionLabel: {
			fontWeight: '600',
			margin: '1em 0 0 0',
			lineHeight: context.themeManager
				.value('event-description', 'lineHeight', 'line-height-300'),
		},
	};

	return (
		props.description &&
		<div>
			<p style={style.descriptionLabel}>Infos zum Event:</p>
			<span className="event__description" style={style.desciptionDefault}>
				{props.description}
			</span>
		</div>
	);
}

export default radium(Description);
